import { customInstance } from "./client";

export interface EmployerEnrichmentResponse {
  mission_vision: string | null;
  funding_traction: string | null;
  culture_principles: string | null;
  benefits: string | null;
}

export interface CreateDefaultEmployerMutationBody {
  mission_vision: string | null;
  funding_traction: string | null;
  culture_principles: string | null;
  benefits: string | null;
}

export interface EmployerProfileResponse {
  id: string;
  name: string;
  mission_vision: string | null;
  funding_traction: string | null;
  culture_principles: string | null;
  benefits: string | null;
}

export const enrichEmployerProfile = () =>
  customInstance<EmployerEnrichmentResponse>(
    "/api/onboarding/employer/enrich",
    { method: "GET" },
  );

export const createDefaultEmployer = (body: CreateDefaultEmployerMutationBody) =>
  customInstance<EmployerProfileResponse>("/api/onboarding/employer", {
    method: "POST",
    body: JSON.stringify(body),
  });
